import React, { useState } from 'react';
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import FormBuilder from './FormBuilder';
import WelcomeScreen from './WelcomeScreen';
import './App.css';

function App() {
  const [showBuilder, setShowBuilder] = useState(false);

  const handleGetStarted = () => {
    setShowBuilder(true);
  };

  return (
    <div className="app">
      {!showBuilder ? (
        <WelcomeScreen onGetStarted={handleGetStarted} />
      ) : (
        <DndProvider backend={HTML5Backend}>
          <FormBuilder />
        </DndProvider>
      )}
    </div>
  );
}

export default App;
